import React from 'react';
import { Box, useTheme } from '@mui/material';
import { MillosMark, MillosWordmark } from '../marketing/components/icons';
import { homepageVariables } from '../theme_landing_page_2';

const MillosLogo: React.FC<{ size?: number; wordmark?: boolean; agent?: boolean }> = ({ size = 32, wordmark = false, agent = false }) => {
  const { palette } = useTheme();
  return (
  <Box component="span" aria-label={wordmark ? 'MillOS' : undefined} aria-hidden={wordmark ? undefined : true}
    sx={{ ...homepageVariables, display: 'inline-flex', alignItems: 'center', gap: 1, flexShrink: 0, verticalAlign: 'middle' }}>
    <Box component="span" sx={{ position: 'relative', display: 'inline-flex', width: size, height: size }}>
      <MillosMark size={size} />
      {agent && (
        <svg data-agent-eyes aria-hidden="true" viewBox="0 0 100 100" width={size} height={size} style={{ position: 'absolute', inset: 0 }}>
          <rect x="27" y="36" width="46" height="28" rx="14" fill={palette.tokens.canvas} />
          <ellipse cx="40" cy="50" rx="4.5" ry="6" fill={palette.tokens.ink} />
          <ellipse cx="60" cy="50" rx="4.5" ry="6" fill={palette.tokens.ink} />
        </svg>
      )}
    </Box>
    {wordmark && <MillosWordmark fontSize="1.5rem" />}
  </Box>
  );
};

export default MillosLogo;
